import { useSelector, useDispatch } from 'react-redux';
import FJVideoRemoveBgCustomExport from '../view/FJVideoRemoveBgCustomExport';
import { useCallback } from 'react';
import FJActionVideoRemoveBg from '../../../../redux/action/FJActionVideoRemoveBg';

const FJVideoRemoveBgAutoExportAfterContainer = () => {
    const dispatch = useDispatch();
    const status = useSelector(state => state.videoBgRemover.autoExportData.exportStatus);
    const progress = useSelector(state => state.videoBgRemover.autoExportData.exportProgress);

    const download = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.autoExportVideoAction());
    }, [dispatch]);

    const goToBack = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.autoExportGoBackAction());
    }, [dispatch]);

    const cancelExport = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.autoCancelExportVideoAction());
    }, [dispatch]);

    const removeMore = useCallback(
        file => {
            dispatch(FJActionVideoRemoveBg.uploadAutoEditVideoAction(file));
        },
        [dispatch],
    );

    return (
        <FJVideoRemoveBgCustomExport
            status={status}
            progress={progress}
            download={download}
            goToBack={goToBack}
            cancelExport={cancelExport}
            removeMore={removeMore}
        />
    );
};

export default FJVideoRemoveBgAutoExportAfterContainer;
